/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_OpenInputs */

const en_cases_filter_open = /** @type {(inputs: Cases_Filter_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const pt_br2_cases_filter_open = /** @type {(inputs: Cases_Filter_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aberto`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Cases_Filter_OpenInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_open = /** @type {((inputs?: Cases_Filter_OpenInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_OpenInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_open(inputs)
	return pt_br2_cases_filter_open(inputs)
});